import { From } from "../Message/Message.Interface";

export enum Channel {
  SMS = "SMS",
  WEB = "Web",
  VOICE = "Voice",

  GOOGLE_MY_BUSINESS = "GMB",
  FACEBOOK_MESSENGER = "FBM",
  WHATSAPP = "WhatsApp",
}

export interface MessageAuth {
  userId: number;
  from: From; // This is the sender, for whom the auth is for.
  orgId: number;
  token: string;
  memberId?: number;
  channel?: Channel;
}
